export default __webpack_public_path__ + "static/media/tip_icon.91e74813.png";